import React from 'react'
import Rect from '../assets/images/rect.png'

function Line() {
  return (
    <div>
      <img src={Rect} alt="" />
    </div>
  )
}

export default Line
